import { render } from "./StatsWidgetColumn.vue?vue&type=template&id=74422929&scoped=true"
import script from "./StatsWidgetColumn.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetColumn.vue?vue&type=script&lang=ts"

import "./StatsWidgetColumn.vue?vue&type=style&index=0&id=74422929&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74422929"

export default script